import { render } from "./EdmChangeRecipientTypeDialog.vue?vue&type=template&id=c90f2024"
import script from "./EdmChangeRecipientTypeDialog.vue?vue&type=script&lang=js"
export * from "./EdmChangeRecipientTypeDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__